import { IconTypeProps, PlusIcon } from '@mm/icons';
import { ColorType, getColorStylesByType } from '@mm/utils';
import classNames from 'classnames';
import React, { MouseEventHandler } from 'react';
import './Chip.pcss';

type Props = {
  className?: string;
  text: string;
  iconProps?: IconTypeProps;
  type?: ColorType;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
};

export const Chip: React.FC<Props> = ({
  children,
  className,
  text,
  type,
  iconProps,
  onClick,
}) => {
  const style = getColorStylesByType(type);

  return (
    <div
      className={classNames(className, 'c-chip')}
      style={type && style}
      onClick={onClick}
    >
      <span className="c-chip__text">{text}</span>
      {children}
      {iconProps && (
        <PlusIcon
          color={style.color}
          className={classNames('c-chip__plus-icon', iconProps.className)}
          {...iconProps}
        />
      )}
    </div>
  );
};
